module.exports = __webpack_public_path__ + "static/media/img_mobile_brand_a_bg.4d458a0c.png";